import one from '@mailobj-browser/front/js/selectors/one.js'
import * as generics from "#components/generics/js/styles.js"
import {scrollTo} from "#components/generics/js/scroll/scrollTo.js"

export default container => {
  const {ownerDocument} = container
  const scrollToElement = one(`.${generics.elements.scroll_to}`, container)

  if (ownerDocument.contains(scrollToElement)) {
    scrollTo(container, {top: scrollToElement.offsetTop})
  }
}
